"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6193],{

/***/ 64094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Brand; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./config/routes.tsx + 2 modules
var routes = __webpack_require__(6635);
// EXTERNAL MODULE: ./lib/classnames.ts
var classnames = __webpack_require__(370);
// EXTERNAL MODULE: ./components/elements/Link/index.tsx
var Link = __webpack_require__(6553);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
;// CONCATENATED MODULE: ./components/basic/Brand/BrandSVG/index.tsx


function BrandSVG(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "110",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "fill-gray-900 dark:fill-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 18.263V0h7.735a5.4 5.4 0 0 1 2.387.527c.723.351 1.348.824 1.875 1.415a6.57 6.57 0 0 1 1.226 1.994c.288.739.434 1.493.434 2.264 0 1.047-.242 2.041-.727 2.985a6.169 6.169 0 0 1-2.018 2.302c-.86.591-1.877.888-3.05.888H4.188v5.89H0v-.002Zm4.188-9.569H7.61c.323 0 .62-.093.892-.282.271-.188.494-.471.664-.85.169-.377.256-.839.256-1.389s-.099-1.033-.295-1.401c-.196-.369-.442-.638-.74-.81a1.85 1.85 0 0 0-.931-.258H4.188v4.99ZM14.552 14.288c0-.878.246-1.647.74-2.306.493-.66 1.176-1.179 2.043-1.559.867-.38 1.864-.57 2.987-.57.545 0 1.081.047 1.608.142.527.095.987.227 1.38.4v-.59c0-.713-.222-1.26-.664-1.642-.443-.381-1.116-.571-2.018-.571-.748 0-1.45.128-2.106.385-.656.258-1.349.626-2.081 1.107L15.215 6.46a10.646 10.646 0 0 1 2.77-1.312c.962-.291 1.98-.438 3.05-.438 2.01 0 3.571.475 4.685 1.424 1.115.95 1.671 2.324 1.671 4.123v3.453c0 .404.064.686.193.845.127.161.352.256.677.291v3.421c-.34.068-.66.12-.958.155a6.837 6.837 0 0 1-.78.052c-.765 0-1.348-.155-1.748-.463-.4-.308-.65-.729-.754-1.26l-.077-.59a6.011 6.011 0 0 1-2.131 1.761 5.83 5.83 0 0 1-2.591.605c-.902 0-1.681-.186-2.387-.559a4.317 4.317 0 0 1-1.672-1.52 3.936 3.936 0 0 1-.613-2.156l.002-.004Zm8.117.486c.187-.149.34-.313.46-.496a.955.955 0 0 0 .179-.521v-1.165a6.221 6.221 0 0 0-1.137-.31 6.727 6.727 0 0 0-1.162-.112c-.748 0-1.37.16-1.864.484-.494.322-.74.748-.74 1.276 0 .296.084.57.255.817.17.248.404.446.702.595.299.15.65.223 1.06.223.41 0 .818-.073 1.226-.223.407-.149.748-.339 1.021-.57M49.247 17.544c-.375.155-.787.308-1.24.463-.451.155-.922.28-1.417.372-.494.095-.979.142-1.456.142a5.042 5.042 0 0 1-1.877-.341 2.79 2.79 0 0 1-1.352-1.128c-.333-.523-.499-1.217-.499-2.08V8.227h-1.71V4.913h1.71V.618h4.086v4.295h2.731v3.314h-2.731v5.307c0 .436.11.75.333.944.22.194.502.289.842.289.289 0 .6-.053.931-.155.333-.103.618-.216.856-.336l.79 3.268h.003ZM50.187 14.288c0-.878.247-1.647.74-2.306.495-.66 1.176-1.179 2.044-1.559.867-.38 1.864-.57 2.987-.57.544 0 1.08.047 1.608.142.527.095.987.227 1.38.4v-.59c0-.713-.222-1.26-.664-1.642-.443-.381-1.116-.571-2.016-.571-.75 0-1.45.128-2.107.385-.655.258-1.348.626-2.08 1.107L50.852 6.46a10.643 10.643 0 0 1 2.77-1.312c.962-.291 1.979-.438 3.05-.438 2.009 0 3.57.475 4.684 1.424 1.114.95 1.672 2.324 1.672 4.123v3.453c0 .404.063.686.192.845.127.161.354.256.677.291v3.421c-.34.068-.66.12-.958.155a6.839 6.839 0 0 1-.779.052c-.765 0-1.348-.155-1.748-.463-.4-.308-.65-.729-.754-1.26l-.077-.59a6.011 6.011 0 0 1-2.131 1.761 5.83 5.83 0 0 1-2.591.605c-.903 0-1.682-.186-2.388-.559a4.317 4.317 0 0 1-1.671-1.52 3.936 3.936 0 0 1-.614-2.156v-.004Zm8.12.486c.186-.149.34-.313.46-.496a.956.956 0 0 0 .178-.521v-1.165a6.221 6.221 0 0 0-1.137-.31 6.729 6.729 0 0 0-1.161-.112c-.749 0-1.37.16-1.864.484-.495.322-.741.748-.741 1.276 0 .296.085.57.256.817.17.248.404.446.702.595.298.15.65.223 1.06.223.41 0 .817-.073 1.225-.223.408-.149.748-.339 1.022-.57M71.198 18.52c-.885 0-1.694-.175-2.425-.526a5.45 5.45 0 0 1-1.876-1.468 7.03 7.03 0 0 1-1.214-2.174 7.951 7.951 0 0 1-.434-2.65c0-.994.154-1.91.46-2.752a7.116 7.116 0 0 1 1.288-2.225 5.77 5.77 0 0 1 1.966-1.492c.758-.35 1.597-.527 2.514-.527 1.004 0 1.889.21 2.655.63a4.802 4.802 0 0 1 1.838 1.787V4.91h3.55v12.48c0 1.36-.328 2.535-.983 3.522-.656.986-1.566 1.748-2.732 2.283-1.166.535-2.514.804-4.047.804-1.43 0-2.66-.236-3.69-.707a8.081 8.081 0 0 1-2.692-1.995l2.196-2.238a5.366 5.366 0 0 0 1.84 1.35 5.571 5.571 0 0 0 2.348.503c.663 0 1.277-.11 1.839-.332a2.834 2.834 0 0 0 1.34-1.066c.333-.49.499-1.147.499-1.973V16.23c-.408.738-1 1.302-1.776 1.698a5.341 5.341 0 0 1-2.464.59v.003Zm1.404-3.269c.323 0 .626-.046.906-.141.281-.095.54-.223.78-.386.238-.163.46-.36.663-.591.204-.23.366-.485.485-.76v-2.83a3.62 3.62 0 0 0-.74-1.248 3.558 3.558 0 0 0-1.072-.81 2.802 2.802 0 0 0-1.225-.283c-.426 0-.826.095-1.2.283-.376.19-.695.46-.959.81a4.185 4.185 0 0 0-.83 2.508c0 .498.08.952.242 1.363.161.41.386.775.677 1.093.288.318.629.562 1.021.732.393.173.808.258 1.25.258M88.737 18.52c-1.14 0-2.152-.181-3.037-.546a6.751 6.751 0 0 1-2.26-1.488 6.382 6.382 0 0 1-1.418-2.175 6.99 6.99 0 0 1-.485-2.581c0-1.28.285-2.446.856-3.499.57-1.052 1.391-1.903 2.464-2.55 1.072-.65 2.366-.973 3.88-.973 1.514 0 2.805.321 3.868.963 1.064.642 1.878 1.48 2.438 2.52a6.993 6.993 0 0 1 .804 4.075l-.064.595h-9.906c.052.584.217 1.076.498 1.475.28.402.642.706 1.085.913.442.21.91.312 1.404.312a3.54 3.54 0 0 0 1.724-.438c.536-.29.906-.686 1.11-1.184l3.472.977a5.795 5.795 0 0 1-1.443 1.864 6.93 6.93 0 0 1-2.195 1.274c-.842.308-1.773.463-2.795.463v.004Zm-2.96-8.184h5.82c-.069-.54-.228-1.01-.484-1.41a2.625 2.625 0 0 0-1.022-.933 3.002 3.002 0 0 0-1.404-.332c-.51 0-1 .111-1.418.332a2.628 2.628 0 0 0-1.007.932 3.365 3.365 0 0 0-.485 1.411ZM38.254 4.913c-.364-.06-1.174-.1-2.16.483-.77.455-1.528 1.182-1.988 2.091V4.915h-3.752v13.348h4.085v-8.101c.358-.619 1.335-1.285 2.135-1.603.589-.233 1.328-.304 1.68-.328V4.913ZM109.815 6.47l-4.541-2.981V4.78c-.427-.011-1.071.074-1.818.514-.769.455-1.527 1.182-1.987 2.091V4.814h-3.753v13.35h4.086v-8.101c.358-.618 1.335-1.285 2.135-1.603.437-.173.954-.256 1.337-.299v1.29l4.541-2.981Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h109.846v24H0z"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/basic/Brand/index.tsx





function Brand(param) {
    var className = param.className, _clickable = param.clickable, clickable = _clickable === void 0 ? true : _clickable;
    if (clickable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: routes/* default.home.getUrl */.Z.home.getUrl(),
            className: (0,classnames/* default */.Z)("my-7 flex justify-center", className),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandSVG, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classnames/* default */.Z)("my-7 flex justify-center", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandSVG, {})
    });
}


/***/ }),

/***/ 80258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Card(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-white border border-gray-100 rounded-lg shadow-md p-6 md:p-11 dark:bg-gray-800 dark:border-gray-700 ".concat(className),
        children: children
    });
}


/***/ }),

/***/ 84240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Spinner(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        role: "status",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            "aria-hidden": "true",
            className: "w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600 ".concat(className),
            viewBox: "0 0 100 101",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                    fill: "currentFill"
                })
            ]
        })
    });
}


/***/ }),

/***/ 51859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Heading2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(370);


function Heading2(param) {
    var variant = param.variant, _level = param.level, level = _level === void 0 ? 2 : _level, className = param.className, children = param.children;
    var variantClass = "font-sans text-lg font-bold text-gray-900 mt-[2em] mb-[1em] dark:text-white";
    if (variant === "frontend") {
        variantClass = "font-sans text-xl lg:text-2xl md:text-3xl font-bold text-gray-900 mt-[2em] mb-[0.5em] md:mb-[1em] dark:text-white";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(variantClass, className),
        "aria-level": level,
        children: children
    });
}


/***/ }),

/***/ 6553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(370);



function Link(param) {
    var href = param.href, className = param.className, children = param.children, _type = param.type, type = _type === void 0 ? "default" : _type, target = param.target, onClick = param.onClick, rel = param.rel;
    var STYLES = {
        default: "underline hover:no-underline active:no-underline focus:no-underline",
        alternative: "no-underline hover:underline active:underline focus:underline",
        "no-underline": "no-underline hover:no-underline active:no-underline focus:no-underline"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            target: target,
            onClick: onClick,
            href: href,
            rel: rel,
            className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(STYLES[type], "cursor-pointer text-gray-800 underline-offset-2 dark:text-gray-300", className),
            children: children
        })
    });
}


/***/ }),

/***/ 99730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(370);


function Paragraph(param) {
    var variant = param.variant, className = param.className, children = param.children;
    var variantClass = "font-sans text-sm font-normal text-gray-700 dark:text-white";
    if (variant === "frontend") {
        variantClass = "font-serif text-lg md:text-xl font-normal text-gray-900 dark:text-white";
    }
    if (variant === "error") {
        variantClass = "font-sans text-sm font-normal text-red-600";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(variantClass, className),
        children: children
    });
}


/***/ }),

/***/ 6475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BasicCardLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(370);
/* harmony import */ var _basic_Brand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64094);
/* harmony import */ var _basic_Card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80258);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87097);





function BasicCardLayout(param) {
    var children = param.children, className = param.className, _showBrand = param.showBrand, showBrand = _showBrand === void 0 ? true : _showBrand, _isBrandClickable = param.isBrandClickable, isBrandClickable = _isBrandClickable === void 0 ? true : _isBrandClickable;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "m-auto p-4 md:p-0",
            children: [
                showBrand && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_Brand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    clickable: isBrandClickable
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_Card__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("max-w-full md:w-[500px]", className),
                    children: children
                })
            ]
        })
    });
}


/***/ }),

/***/ 87097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BasicLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(370);


function BasicLayout(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("bg-gray-50 dark:bg-gray-900 min-h-screen flex", className),
        children: children
    });
}


/***/ }),

/***/ 12400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function Seo(param) {
    var title = param.title, description = param.description, image = param.image, type = param.type, url = param.url, author = param.author, createdAt = param.createdAt, thematic = param.thematic, _isCanonical = param.isCanonical, isCanonical = _isCanonical === void 0 ? false : _isCanonical;
    var fullUrl = "".concat("https://partager.io").concat(url);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@partager.io"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: "@partager.io"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image:src",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: author
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: fullUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Partager.io"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:published_time",
                content: createdAt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:author",
                content: author
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:section",
                content: thematic
            }),
            isCanonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: fullUrl
            })
        ]
    });
}


/***/ }),

/***/ 15768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_K": function() { return /* reexport */ confirmUserToken; },
  "nS": function() { return /* reexport */ googleSignIn; },
  "_B": function() { return /* reexport */ magicSignIn; },
  "Je": function() { return /* reexport */ remindPassword; },
  "c0": function() { return /* reexport */ resetPassword; },
  "pr": function() { return /* reexport */ sendMagicLink; },
  "VG": function() { return /* reexport */ usernameLoginSignIn; }
});

// UNUSED EXPORTS: getUser, googleProvider

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./config/routes.tsx + 2 modules
var routes = __webpack_require__(6635);
// EXTERNAL MODULE: ./lib/request.ts
var request = __webpack_require__(87888);
;// CONCATENATED MODULE: ./features/auth/auth.service.ts






var APP_URL = "https://partager.io";
function getUser(tokenJWT) {
    return _getUser.apply(this, arguments);
}
function _getUser() {
    _getUser = _async_to_generator(function(tokenJWT) {
        var queryStringUser, data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    queryStringUser = QueryString.stringify({
                        populate: {
                            avatar: {
                                fields: [
                                    "url",
                                    "name",
                                    "provider_metadata"
                                ]
                            }
                        }
                    });
                    return [
                        4,
                        getAxiosAPI("/users/me?".concat(queryStringUser), tokenJWT)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _getUser.apply(this, arguments);
}
function googleProvider(token, accessToken) {
    return _googleProvider.apply(this, arguments);
}
function _googleProvider() {
    _googleProvider = _async_to_generator(function(token, accessToken) {
        var newToken, response, data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    newToken = token;
                    return [
                        4,
                        getAxiosAPI("/auth/google/callback?access_token=".concat(accessToken))
                    ];
                case 1:
                    response = _state.sent();
                    data = response.data;
                    newToken.jwt = data.jwt;
                    newToken.id = data.user.id;
                    return [
                        2,
                        newToken
                    ];
            }
        });
    });
    return _googleProvider.apply(this, arguments);
}
function usernameLoginSignIn(email, password) {
    return (0,react.signIn)("username-login", {
        redirect: false,
        email: email,
        password: password
    });
}
function magicSignIn(loginToken) {
    return (0,react.signIn)("magic", {
        redirect: false,
        token: loginToken
    });
}
function confirmUserToken(confirmation) {
    return (0,react.signIn)("confirm-token-login", {
        callbackUrl: "".concat(APP_URL).concat(routes/* default.onboardingProfile.getUrl */.Z.onboardingProfile.getUrl()),
        confirmationToken: confirmation
    });
}
function googleSignIn() {
    return (0,react.signIn)("google");
}
function resetPassword(password, passwordConfirmation, code) {
    return _resetPassword.apply(this, arguments);
}
function _resetPassword() {
    _resetPassword = (0,src_async_to_generator/* default */.Z)(function(password, passwordConfirmation, code) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,request/* postAxiosAPI */.pW)("/auth/reset-password", {
                            password: password,
                            passwordConfirmation: password,
                            code: code
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _resetPassword.apply(this, arguments);
}
function sendMagicLink(email, redirect) {
    return _sendMagicLink.apply(this, arguments);
}
function _sendMagicLink() {
    _sendMagicLink = (0,src_async_to_generator/* default */.Z)(function(email, redirect) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,request/* postAxiosAPI */.pW)("/passwordless/send-link", {
                            email: email,
                            redirect: redirect
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _sendMagicLink.apply(this, arguments);
}
function remindPassword(email) {
    return _remindPassword.apply(this, arguments);
}
function _remindPassword() {
    _remindPassword = (0,src_async_to_generator/* default */.Z)(function(email) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,request/* postAxiosAPI */.pW)("/auth/forgot-password", {
                            email: email
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _remindPassword.apply(this, arguments);
}

;// CONCATENATED MODULE: ./features/auth/index.ts



/***/ })

}]);